// Ocho misiones de Planeta Multiplicación: banco dinámico y sin repeticiones en una partida.
import { rnd } from '../math/operations';

export const MULTIPLICACION_MISSIONS = [
  { index: 0, num: 1, name: 'Planeta 1', skill: 'Multiplicación: 1 dígito × 1 dígito', desc: 'Multiplica números del 0 al 9.', type: 'one_by_one', time: 120 },
  { index: 1, num: 2, name: 'Planeta 2', skill: 'Multiplicación: 2 dígitos × 1 dígito', desc: 'Multiplica un número de dos dígitos por uno de un dígito.', type: 'two_by_one', time: 150 },
  { index: 2, num: 3, name: 'Planeta 3', skill: 'Multiplicación: 3 dígitos × 1 dígito', desc: 'Multiplica un número de tres dígitos por uno de un dígito.', type: 'three_by_one', time: 180 },
  { index: 3, num: 4, name: 'Planeta 4', skill: 'Multiplicación: 4 dígitos × 1 dígito', desc: 'Multiplica un número de cuatro dígitos por uno de un dígito.', type: 'four_by_one', time: 210 },
  { index: 4, num: 5, name: 'Planeta 5', skill: 'Multiplicación: 2 dígitos × 2 dígitos', desc: 'Multiplica dos números de dos dígitos.', type: 'two_by_two', time: 210 },
  { index: 5, num: 6, name: 'Planeta 6', skill: 'Multiplicación: 3 dígitos × 2 dígitos', desc: 'Multiplica tres dígitos por dos dígitos.', type: 'three_by_two', time: 240 },
  { index: 6, num: 7, name: 'Planeta 7', skill: 'Multiplicación: 4 dígitos × 2 dígitos', desc: 'Multiplica cuatro dígitos por dos dígitos.', type: 'four_by_two', time: 270 },
  { index: 7, num: 8, name: 'Planeta 8', skill: 'Multiplicación: destrezas mixtas', desc: 'Combina todas las destrezas del Bosque de los Factores.', type: 'mixed', time: 240 },
];

const oneByOne = () => ({ a: rnd(0, 9), b: rnd(0, 9) });
const twoByOne = () => ({ a: rnd(10, 99), b: rnd(1, 9) });
const threeByOne = () => ({ a: rnd(100, 999), b: rnd(1, 9) });
const fourByOne = () => ({ a: rnd(1000, 9999), b: rnd(1, 9) });
const twoByTwo = () => ({ a: rnd(10, 99), b: rnd(10, 99) });
const threeByTwo = () => ({ a: rnd(100, 999), b: rnd(10, 99) });
const fourByTwo = () => ({ a: rnd(1000, 9999), b: rnd(10, 99) });

const GENERATORS = {
  one_by_one: oneByOne,
  two_by_one: twoByOne,
  three_by_one: threeByOne,
  four_by_one: fourByOne,
  two_by_two: twoByTwo,
  three_by_two: threeByTwo,
  four_by_two: fourByTwo,
};

export function genMultiplication(type) {
  if (type === 'mixed') {
    const keys = Object.keys(GENERATORS);
    return GENERATORS[keys[rnd(0, keys.length - 1)]]();
  }
  return (GENERATORS[type] || GENERATORS.one_by_one)();
}
